import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { PaginationV8 } from '@va/ui/components/data-table/PaginationV8';
import { useManageWebsitesContext } from './ManageWebsiteContext';

const ManageWebsitesPagination = () => {
  const { totalWebsites, pagination, setPagination } = useManageWebsitesContext();

  const table = useReactTable({
    columns: [],
    data: [],
    getCoreRowModel: getCoreRowModel(),
    rowCount: totalWebsites,
    state: { pagination },
    onPaginationChange: setPagination,
  });

  return <PaginationV8 table={table} />;
};

export default ManageWebsitesPagination;
